import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { DashboardBigCard } from '../components'
import { sum } from 'lodash'

export const AccreditationTotalBox = ({ accreditation }) => {
  const { t } = useTranslation()

  const getAccreditationPercentage = (item) => {
    const total = (item?.active || 0) + (item?.inactive || 0)
    if (total === 0) return null

    const percentage = Number(item?.percentage)
    if (!Number.isFinite(percentage)) return null

    return percentage * 100
  }

  const percentages = [
    getAccreditationPercentage(accreditation.employees),
    getAccreditationPercentage(accreditation.contracts),
    getAccreditationPercentage(accreditation.companies),
    getAccreditationPercentage(accreditation.assets)
  ]
  const filteredPercentages = percentages.filter(percentage => Number.isFinite(percentage))
  const total = filteredPercentages.length ? (sum(filteredPercentages) / filteredPercentages.length).toFixed(1) : null

  return (
    <DashboardBigCard
      title={t('dashboard.card.totalAccreditedPeople.title')}
      value={total}
      tooltipTitle={t('dashboard.card.totalAccreditedPeople.tooltipTitle')}
      tooltipDescription={t(
        'dashboard.card.totalAccreditedPeople.tooltipDescription'
      )}
    />
  )
}

AccreditationTotalBox.propTypes = {
  accreditation: PropTypes.object.isRequired
}
